module.exports = __webpack_public_path__ + "static/media/Dr.タナカーソン.b1f92311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/Dr.タナカーソン.png
// module id = 300
// module chunks = 10